module.exports = __webpack_public_path__ + "static/hiveonasic-header-8c9828971e87a2eda69d5fed915cad6d.svg";